"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ResultadosRealesConPrecisiN() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const stats = [{
    label: "Excelencia clínica"
  }, {
    label: "Resultados naturales"
  }, {
    label: "Atención personalizada"
  }];
  return <section data-section-id="849" id="resultados-reales-con-precisión" className="relative w-full min-h-[90vh] bg-background text-foreground overflow-hidden">
      {}
      <div aria-hidden="true" className="absolute inset-y-0 left-0 w-full lg:w-[58%] pointer-events-none" style={{
      backgroundImage: "linear-gradient(to right, var(--foreground) 1px, transparent 1px), linear-gradient(to bottom, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "48px 48px",
      opacity: 0.04
    }} />

      <div className="relative grid grid-cols-1 lg:grid-cols-[58%_42%] min-h-[90vh]">
        {}
        <div ref={leftRef} className={`relative flex flex-col justify-center px-6 sm:px-10 lg:pl-[120px] lg:pr-12 py-20 lg:py-24 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <div className="flex items-center gap-3 mb-8 font-mono text-xs tracking-widest uppercase text-accent-foreground">
            
            
            <span><br /></span>
            
            
          </div>

          {}
          <h1 className="font-serif font-default text-foreground mb-8" style={{
          fontSize: "clamp(3rem, 7vw, 7rem)",
          lineHeight: "0.95",
          letterSpacing: "-0.03em"
        }}>
            Resultados reales,{" "}
            <span className="relative inline-block italic">
              tratados
              <span aria-hidden="true" className={`absolute left-0 right-0 -bottom-1 h-[3px] bg-primary origin-left transition-transform duration-1000 ease-out delay-500 ${leftVisible ? "scale-x-100" : "scale-x-0"}`} />
            </span>{" "}
            con precisión.
          </h1>

          {}
          <p className="font-default text-base sm:text-lg text-foreground/80 max-w-2xl mb-10 leading-relaxed">
            En MS Instituto Capilar, combinamos rigor médico y sensibilidad estética para devolverte la densidad y confianza que mereces, con un enfoque humano y natural.
          </p>

          {}
          <div className="flex flex-wrap items-center gap-6 mb-10">
            <Button asChild size="lg" className="rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 px-7 h-12 shadow-md">
              <Link href="https://msinstitutocapilar.com/contacto/" newTab>
                Solicitar consulta
                <ArrowRight className="ml-1 size-4" />
              </Link>
            </Button>

            <Link className="relative underline cursor-pointer" href="https://​msinstitutocapilar.com/casos-de-exito/" newTab>
              <span>Ver casos de éxito<span aria-hidden="true" className="absolute left-0 -bottom-0.5 h-px w-full bg-foreground scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-300" data-ast-id="f:/src/pages/HairSurgery/sections/ResultadosRealesConPrecisiN.tsx|sig:pr7w4k" data-ast-start="3339" data-ast-end="3512"></span></span>
              <span aria-hidden="true">→</span>
            </Link>
          </div>

          {}
          <div className="h-px w-full max-w-2xl bg-border mb-6" />

          {}
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 font-mono text-xs uppercase tracking-wider text-foreground/60">
            {stats.map((stat, i) => <div data-index={i} key={i} className="flex items-center gap-5">
                {i > 0 && <span className="text-primary">·</span>}
                <span>{stat.label}</span>
              </div>)}
          </div>
        </div>

        {}
        <div ref={rightRef} className={`relative w-full h-[60vh] lg:h-auto lg:min-h-[90vh] transition-all duration-1000 ease-out ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-6"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/dra_soto_clinic_consultation.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/dra_soto_clinic_consultation.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/dra_soto_clinic_consultation.webp-wvc-sizes" alt="Dra. María del Carmen Soto en consulta capilar" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" style={{
          filter: "saturate(0.85) contrast(1.05)"
        }} src="https://msinstitutocapilar.com/wp-content/uploads/2026/07/WhatsApp-Image-2026-06-27-at-10.50.26-3.jpeg" />
          {}
          <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{
          boxShadow: "inset 0 0 80px 0 hsla(225, 54%, 10%, 0.35)"
        }} />

          {}
          <div className={`absolute bottom-6 left-6 sm:bottom-10 sm:-left-8 lg:-left-12 z-10 bg-card text-card-foreground rounded-lg shadow-2xl p-5 sm:p-6 w-[260px] sm:w-[280px] transition-all duration-1000 ease-out delay-700 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="flex items-center gap-2.5 mb-3">
              <span className="relative flex h-2.5 w-2.5">
                <span className="absolute inline-flex h-full w-full rounded-lg bg-primary opacity-75 animate-ping" />
                <span className="relative inline-flex rounded-lg h-2.5 w-2.5 bg-primary" />
              </span>
              <span className="font-default text-sm font-semibold text-foreground">
                Agenda abierta
              </span>
            </div>
            <div className="font-mono text-xs uppercase tracking-wider text-primary">
              [ C/ Cruces 7, Las Rozas ]
            </div>
          </div>
        </div>
      </div>
    </section>;
}